// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-groups-container {
  max-width: 1250px;
  padding-left: 15px;
  padding-right: 15px;
  margin: 0 18%;
}

@media only screen and (max-width: 1024px) {
  .manage-groups-container {
    margin: auto;
    padding-top: 40px;
  }
}
.move-device-group-heading {
  padding-top: 10px;
  margin: 24px 0px;
  font: 38px/25px "Omnes-ATT-W02-Light";
}
@media only screen and (max-width: 1024px) {
  .move-device-group-heading {
    font: 20px "Omnes-ATT-W02-Light";
    margin-top: 60px;
  }
}

.move-device-group-subheading {
  font-size: 16px;
  padding-top: 10px;
  margin-bottom: 34px;
}

.move-device-group-note {
  font-size: 16px;
  padding-top: 10px;
  margin-bottom: 10px;
}
@media only screen and (max-width: 1024px) {
  .move-device-group-note {
    font-size: 16px;
  }
}

.manage-group-success-banner {
  margin-top: 80px;
}

.alert {
  margin-top: -60px;
}

#lineStyle {
  opacity: 0.5;
  margin: 0 0 15px 0;
  border: 0.5px solid #D1D2D3 !important;
}

.move-device-group-link {
  margin-left: 20px;
}
@media only screen and (max-width: 767px) {
  .move-device-group-link {
    display: block;
    margin-left: 0px;
    margin-top: 15px;
  }
}

table {
  table-layout: fixed;
}

.grid-table {
  margin-top: 35px;
}
.grid-table .table {
  border-collapse: inherit;
  margin-bottom: 30px !important;
}
.grid-table tr th {
  padding-top: 10px;
  padding-bottom: 5px;
  font-size: 16px;
  font: bold;
}
.grid-table tr td {
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #d2d2d2;
}

.first-col {
  text-align: left;
  padding-left: 0px;
}

.first-col-content {
  text-align: left;
  padding-left: 4px;
  overflow-wrap: break-word;
}

.second-col {
  text-align: center;
}
@media only screen and (max-width: 767px) {
  .second-col {
    text-align: center;
  }
}

.second-col-content {
  text-align: center;
  padding-left: 10px;
}
@media only screen and (max-width: 767px) {
  .second-col-content {
    text-align: center;
  }
}

.third-col {
  text-align: right;
}
.third-col img {
  width: 22px;
}

.third-col-content {
  text-align: right;
}
.third-col-content img {
  width: 22px;
}

@media only screen and (max-width: 400px) {
  .third-col {
    text-align: center;
  }
  .third-col-content {
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/manage-groups/manage-groups.component.scss"],"names":[],"mappings":"AAAA;EAEC,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AAAD;;AAGA;EACE;IACE,YAAA;IACA,iBAAA;EAAF;AACF;AAGA;EAEC,iBAAA;EACA,gBAAA;EACA,qCAAA;AAFD;AAIC;EAND;IAOE,gCAAA;IACA,gBAAA;EADA;AACF;;AAIA;EACC,eAAA;EACA,iBAAA;EACA,mBAAA;AADD;;AAQA;EACC,eAAA;EACA,iBAAA;EACA,mBAAA;AALD;AAOC;EALD;IAME,eAAA;EAJA;AACF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;;AAQA;EAEC,YAAA;EACA,kBAAA;EACA,sCAAA;AAND;;AASA;EACC,iBAAA;AAND;AAQE;EAHF;IAKE,cAAA;IACA,gBAAA;IACA,gBAAA;EANA;AACF;;AAWA;EACE,mBAAA;AARF;;AAWA;EAEC,gBAAA;AATD;AAWC;EACC,wBAAA;EACA,8BAAA;AATF;AAaE;EAEC,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AAZH;AAmBG;EACC,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,gCAAA;AAjBJ;;AAwBA;EACC,gBAAA;EACA,iBAAA;AArBD;;AAuBA;EACE,gBAAA;EACA,iBAAA;EACA,yBAAA;AApBF;;AAwBA;EACE,kBAAA;AArBF;AAuBE;EAHF;IAII,kBAAA;EApBF;AACF;;AAsBA;EACE,kBAAA;EACA,kBAAA;AAnBF;AAqBE;EAJF;IAKI,kBAAA;EAlBF;AACF;;AAsBA;EACC,iBAAA;AAnBD;AAoBC;EACC,WAAA;AAlBF;;AA6BA;EACE,iBAAA;AA1BF;AA2BE;EACC,WAAA;AAzBH;;AA8BC;EACC;IACE,kBAAA;EA3BF;EA6BA;IACE,kBAAA;EA3BF;AACF","sourcesContent":[".manage-groups-container{\n\n max-width: 1250px;\n padding-left: 15px;\n padding-right: 15px;\n margin: 0 18%;\n}\n\n@media only screen and (max-width: 1024px) {\n  .manage-groups-container{\n    margin: auto;\n    padding-top: 40px;\n  }\n}\n\n.move-device-group-heading{\n // font-size: 38px;\n padding-top: 10px;\n margin: 24px 0px;\n font: 38px/25px 'Omnes-ATT-W02-Light';\n//  font-weight:bold;\n @media only screen and (max-width: 1024px){\n  font: 20px 'Omnes-ATT-W02-Light';\n  margin-top: 60px;\n }\n}\n\n.move-device-group-subheading{\n font-size: 16px;\n padding-top: 10px;\n margin-bottom: 34px;\n // font-family: 'ATT Aleck Sans';\n//  @media only screen and (max-width: 768px){\n//   font-size: 16px;\n//  }\n}\n\n.move-device-group-note{\n font-size: 16px;\n padding-top: 10px;\n margin-bottom: 10px;\n // font-family: 'ATT Aleck Sans';\n @media only screen and (max-width: 1024px){\n  font-size: 16px;\n }\n}\n\n.manage-group-success-banner {\n  margin-top: 80px;\n}\n\n.alert {\n  margin-top: -60px;\n}\n\n\n#lineStyle{\n // border: 1px #D1D2D3;\n opacity: .5;\n margin: 0 0 15px 0;\n border: 0.5px solid #D1D2D3 !important;\n}\n\n.move-device-group-link{\n margin-left: 20px;\n//  @media (min-width:769px) and (max-width:1024px){\n  @media only screen and (max-width: 767px){\n\n  display: block;\n  margin-left:0px;\n  margin-top: 15px;\n }\n\n}\n\n\ntable {\n  table-layout: fixed;\n}\n\n.grid-table {\n\n margin-top: 35px;\n\n .table {\n  border-collapse: inherit;\n  margin-bottom: 30px !important;\n }\n\n tr {\n  th {\n   // display:cell;\n   padding-top: 10px;\n   padding-bottom: 5px;\n   font-size: 16px;\n   font:bold;\n\n  }\n }\n\n\n  tr {\n   td {\n    font-size: 16px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #d2d2d2;\n   }\n  }\n \n\n}\n\n.first-col{\n text-align:left;\n padding-left:0px;\n}\n.first-col-content{\n  text-align:left;\n  padding-left:4px;\n  overflow-wrap: break-word;\n }\n\n\n.second-col {\n  text-align: center;\n\n  @media only screen and (max-width: 767px) {\n    text-align: center;\n  }\n}\n.second-col-content {\n  text-align: center;\n  padding-left:10px;\n\n  @media only screen and (max-width: 767px) {\n    text-align: center;\n  }\n}\n\n\n.third-col{\n text-align:right;\n img{\n  width:22px;\n }\n\n}\n\n// @media only screen and (max-width: 400px) {\n//   .third-col{\n//     display: flex;\n//   }\n// }\n\n.third-col-content{\n  text-align:right;\n  img{\n   width:22px;\n  }\n \n }\n\n @media only screen and (max-width: 400px) {\n  .third-col{\n    text-align:center;\n   }\n  .third-col-content{\n    text-align:center;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
